import React from "react";

import DeleteIcon from "@mui/icons-material/Delete";
import { Button, IconButton, TextField, Typography } from "@mui/material";
import { Stack } from "@mui/system";

type TextFieldEvent = React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>;

export type Outcome = {
  value: string;
  description: string;
};

type Props = {
  title: string;
  description: string;
  outcomes: Outcome[];
  onOutcomesChange: (outcomes: Outcome[]) => void;
};

const OtherImpacts: React.FC<Props> = ({ title, description, outcomes, onOutcomesChange }) => {
  const handleValueChange = (ev: TextFieldEvent, index: number) => {
    const newStrings = [...outcomes];
    newStrings[index] = { ...newStrings[index], value: ev.target.value };
    onOutcomesChange(newStrings);
  };

  const handleDescriptionChange = (ev: TextFieldEvent, index: number) => {
    const newStrings = [...outcomes];
    newStrings[index] = { ...newStrings[index], description: ev.target.value };
    onOutcomesChange(newStrings);
  };

  const handleDeleteOutcome = (index: number) => {
    const newOutcomes = outcomes.filter((_, i) => i !== index);
    onOutcomesChange(newOutcomes);
  };

  const handleAddNewOutcome = () => {
    onOutcomesChange([...outcomes, { value: "0", description: "" }]);
  };

  return (
    <>
      <Typography
        variant="h4"
        sx={{
          mt: 3,
          mb: 1,
          fontSize: 16,
        }}
      >
        {title}
      </Typography>
      <Typography variant="body2" gutterBottom sx={{ mb: 2 }}>
        {description}
      </Typography>
      {outcomes?.map((outcomeDescription, index) => (
        <Stack
          direction="row"
          spacing={2}
          key={`outcome-${index}`}
          sx={{
            mb: 2,
          }}
        >
          <TextField
            onChange={(ev) => {
              handleValueChange(ev, index);
            }}
            label="Value"
            type="number"
            value={outcomeDescription.value}
            sx={{ width: "30%", mt: 3 }}
            required
          />
          <TextField
            onChange={(ev) => {
              handleDescriptionChange(ev, index);
            }}
            label="Description"
            fullWidth
            value={outcomeDescription.description}
            sx={{ mt: 3 }}
            required
          />
          <IconButton
            aria-label="delete-outcome"
            onClick={() => {
              handleDeleteOutcome(index);
            }}
          >
            <DeleteIcon fontSize="inherit" sx={{ fontSize: "22px", color: "error" }} />
          </IconButton>
        </Stack>
      ))}
      <Button sx={{ mb: 3 }} variant="outlined" onClick={handleAddNewOutcome}>
        Add
      </Button>
    </>
  );
};

export default OtherImpacts;
